import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import swal from 'sweetalert';
import axios from 'axios';
import Select from "react-select";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const CfoVerification = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	
	const today = new Date().toISOString().split("T")[0];
    const currentMonthYear = new Date().toISOString().slice(0, 7);

	const [user, setUser] = useState({
        month_year: currentMonthYear,
		action:'fetch',
		department:'0',
		employee_id:'0'

    })



	

	const [selectedMonth, setSelectedMonth] = useState(new Date());
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [dialogmakepayment, setdialogmakepayment]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);
    const [toggle,setToggle]=useState(false);
	const [checkedItems, setCheckedItems] = useState({});
	const [reportType, setReportType] = useState("salary_report");
   const[monthName,setMonthName]=useState("");
    const[totalAmount,settotalAmount]=useState("");

    const { sortConfig, sortData, handleSort } = useSortData();
    
	

    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }



        const [empinfo, setEmpInfo] = useState({
            emp_id: "",
            shift_code: "",
            shift_date:"",
            user_id:"",
            emp_info:"",
        })
    
    
    
    
        const handelEditInput = (event) => {
            event.preventDefault();
            const { name, value } = event.target;
            console.log(name, value)
            setEmpInfo({ ...empinfo, [name]: value });
    
            // if (event.target.value === '1') {
            //     setIsVisible(true);
            //   } else {
            //     setIsVisible(false);
            //   }
        }


    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage,setEntriesPerPage]=useState(10);
    const searchableFields = [
  "employee_id",
  "employee_name",
  "dept_name",
  "total_days",
  "gross_salary",
  "lop",
  "calc_gross_salary",
  "pay_amt",
];

const safe = (val) => String(val ?? "").toLowerCase();

const filteredItems =
  searchTerm.trim() === ""
    ? records
    : records.filter((item) =>
        searchableFields.some((field) =>
          safe(item[field]).includes(searchTerm.toLowerCase())
        )
      );

    const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;
    // const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

    const sortedItems = sortData(filteredItems);
		const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
    
    useEffect(() => {
      setCurrentPage(1);
    }, [searchTerm]);
    
    // const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
    const handleSearch = (event) => {
    //console.log(event.target.value);
     setSearchTerm(event.target.value);
    };


   const clearInput = () => {
		setSearchTerm("");
	  };
	

	
	//   const handleRowsPerPageChange = (e) => {
	// 	setItemsPerPage(Number(e.target.value));
	// 	setCurrentPage(1); // Reset to first page
	//   };



	    const handleDepartment = async () => {
	  
			axios.get(API_BASE_URL +'/showdepartment', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      }
    })
			.then(res1 => setdataval(res1.data))
			.catch(err => console.log(err))
		   };
	  
	  
		   useEffect(() => {
			handleDepartment();
		  }, []);



const handleCfoVerified = async () => {

 const confirm = await swal({
    title: 'Are you sure?',
    text: `To mark salary for ${user.month_year} as verified for all selected employee`,
    icon: 'warning',
    buttons: true,
    dangerMode: true,
  });

  if (!confirm) return swal('Request aborted!');



  // const pay_id = Object.values(checkedItems).filter(Boolean); // e.g., ["NTREQ-INPR-MAKEPAYMENTiD", "NTREQ-3247-2025-07"]
  // alert(JSON.stringify(pay_id, null, 2));
  // alert(pay_id.length);

  const pay_id = filteredData
    .filter(row => checkedItems[row.employee_id])
    .map(row => checkedItems[row.employee_id]);

  // alert(JSON.stringify(pay_id, null, 2));
 
  if (pay_id.length === 0) {
    return toast.warn("No employees selected");
  }

  const payload = {
    edit_type: "mark_cfo_verified",
	month_year:user.month_year,
    pay_id: pay_id,
    // optionally: month_year: user.month_year
  };

  try {
    const res = await axios.post(API_BASE_URL + '/updateSalaryStatus', payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      }
    });

    if (res.data.result) {
   swal({
      title: 'Success',
      text: res.data.result,
      icon: 'success',
    }).then(() => {
      setCheckedItems({});
      fetchPayslipList();   // refresh table
    });
} else {
       return swal({
        text: res.data.error,
        icon: 'error',
		buttons: true,
		dangerMode: true,
      });
    }
  } catch (err) {
    console.error(err);
	 return swal({
        text:"API error occurred",
        icon: 'error',
		buttons: true,
		dangerMode: true,
      });
    
  }
};

 const handleUpdatePayslip = async (id) => {
    window.open(API_BASE_URL +'/payslip/'+id, '_blank')

    // axios.get(API_BASE_URL +'/payslip/'+id, {
    // 	headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    // })
    // .then(res1 => setUser(res1.data))
    // .catch(err => console.log(err))
     };


 

const handleUpdate = async (user_id,attn_date) => {

		// console.log(user_id);
		// console.log(attn_date);
		try{

		const res =await axios.get(API_BASE_URL + '/pay_monthly/' + user_id +'/'+attn_date, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
		   
			console.log(res.data.dialog_make_payment);
			setdialogmakepayment(res.data.dialog_make_payment);

    // Use jQuery to show modal
    setTimeout(() => {
      window.$('#payslipDetailsModal').modal('show');
    }, 100);
  } catch (err) {
    console.error(err);
    toast.error("Error fetching payslip data.");
  }
};


  
 useEffect(()=> {


  setLoading(true);
	axios.post(API_BASE_URL +'/cfo_payslip_list',{ month_year: user.month_year,  department_id: user.department,employee_id: user.employee_id,action:user.action }, {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	

    // .then(response =>console.log(response.data.payslip_list))
	 .then((response) => {
    // console.log(response.data.cfo_payslip_list);
      const data = response.data.cfo_payslip_list;
      setRecords(data);
      setMonthName(response.data.month_name);
      settotalAmount(response.data.total_amount);

      // ✅ Set all checkboxes to checked by default
     const defaultChecked = {};
response.data.cfo_payslip_list.forEach(item => {

  if (item.account_status == 1 && item.acc_verified === "NTREQ") {
    return; // Do NOT add to defaultChecked
  }


  defaultChecked[item.employee_id] =
    `${item.acc_verified}-${item.is_paid}-${item.make_payment_id}`; // ✅ store actual string!
});
setCheckedItems(defaultChecked);
      setLoading(false);
    })
    .catch((err) => console.log(err));
}, []);


  const fetchPayslipList = async () => {
     setLoading(true);
  try {
    // console.log(user.month_year);
    const res = await axios.post(API_BASE_URL + '/cfo_payslip_list', {
      month_year: user.month_year,
      department_id: user.department,
      employee_id: user.employee_id,
      action: user.action
    }, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });

	// console.log(res.data);
    // console.log(res.data.cfo_payslip_list);
    setRecords(res.data.cfo_payslip_list);
    setMonthName(res.data.month_name);
    settotalAmount(res.data.total_amount);

	const defaultChecked = {};
res.data.cfo_payslip_list.forEach(item => {

if (item.account_status == 1 && item.acc_verified === "NTREQ") {
    return; // Do NOT add to defaultChecked
  }

  defaultChecked[item.employee_id] =
    `${item.acc_verified}-${item.is_paid}-${item.make_payment_id}`; // ✅ store actual string!
});
setCheckedItems(defaultChecked);
 setLoading(false);

  } catch (error) {
  console.error("Payslip fetch failed", error.response?.data || error.message);

  const backendError =
    error.response?.data?.error ||
    error.response?.data?.message ||
    error.message;

  toast.error(backendError);
}
};


async function downloadSalaryXls(dateStr: string) {
  const url = `/api/salary-report?month_year=${encodeURIComponent(dateStr)}`;
  const res = await fetch(url, {
	method: 'GET',
	headers: { 'Accept': 'application/vnd.ms-excel' },
	// include auth headers if your API is protected
  });
  if (!res.ok) {
	const err = await res.json().catch(() => ({}));
	throw new Error(err.error || `Download failed (${res.status})`);
  }
  const blob = await res.blob();
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `salary_report_${dateStr}.xls`;
  a.click();
  URL.revokeObjectURL(a.href);
}


const toLastDateISO = (monthYear) => {
  if (!monthYear) return '';
  const parts = monthYear.replace('/', '-').split('-');
  let y, m;
  if (parts[0].length === 4) { y = +parts[0]; m = +parts[1] - 1; } else { m = +parts[0] - 1; y = +parts[1]; }
  return new Date(y, m + 1, 0).toISOString().slice(0, 10);
};

const filenameFromHeaders = (headers, fallback) => {
  const cd = headers.get('Content-Disposition') || '';
  const m = /filename\*?=(?:UTF-8''|")?([^";]+)/i.exec(cd);
  return m ? decodeURIComponent(m[1]) : fallback;
};


async function downloadSalaryXls({ monthYear, department = '0', reportType = 'salary_report', token }) {
  // Pick the right path based on where your route lives:
  // routes/api.php  -> '/api/salary-report'
  // routes/web.php  -> '/salary-report'
  const PATH = '/salary_report'; // change to '/salary-report' if your route is in web.php

  const monthDate = toLastDateISO(monthYear); // "2025-07" -> "2025-07-31"

  

  const q = new URLSearchParams({
	month_year: monthDate,
	// department: String(department),
	// report_type: reportType,
  });
  



  const res = await fetch(`${API_BASE_URL}${PATH}?${q.toString()}`, {
	method: 'GET',
	headers: {
	  'Accept': 'application/vnd.ms-excel',
	  ...(localStorage.getItem('authToken') ? { Authorization: 'Bearer ' + localStorage.getItem('authToken') } : {}),
	},
	// credentials: 'include', // keep if your API uses session cookies
  });

  //console.log(res);

  if (!res.ok) {
	const text = await res.text().catch(() => '');
	throw new Error(`Download failed (${res.status}) ${text.slice(0, 200)}`);
  }

  const blob = await res.blob();
  const filename = filenameFromHeaders(res.headers, `salary_report_${monthYear}.xls`);
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}


async function downloadBankXls({ monthYear, department = '0', reportType = 'bank_report', token }) {
  // Pick the right path based on where your route lives:
  // routes/api.php  -> '/api/salary-report'
  // routes/web.php  -> '/salary-report'
  const PATH = '/bank_report'; // change to '/salary-report' if your route is in web.php

  const monthDate = toLastDateISO(monthYear); // "2025-07" -> "2025-07-31"

  

  const q = new URLSearchParams({
	month_year: monthDate,
	// department: String(department),
	// report_type: reportType,
  });
  



  const res = await fetch(`${API_BASE_URL}${PATH}?${q.toString()}`, {
	method: 'GET',
	headers: {
	  'Accept': 'application/vnd.ms-excel',
	  ...(localStorage.getItem('authToken') ? { Authorization: 'Bearer ' + localStorage.getItem('authToken') } : {}),
	},
	// credentials: 'include', // keep if your API uses session cookies
  });

  //console.log(res);

  if (!res.ok) {
	const text = await res.text().catch(() => '');
	throw new Error(`Download failed (${res.status}) ${text.slice(0, 200)}`);
  }

  const blob = await res.blob();
  const filename = filenameFromHeaders(res.headers, `bank_report_${monthYear}.xls`);
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}




async function downloadEsiXls({ monthYear, department = '0', reportType = 'esi', token }) {
  // Pick the right path based on where your route lives:
  // routes/api.php  -> '/api/salary-report'
  // routes/web.php  -> '/salary-report'
  const PATH = '/esi_report'; // change to '/salary-report' if your route is in web.php

  const monthDate = toLastDateISO(monthYear); // "2025-07" -> "2025-07-31"

  

  const q = new URLSearchParams({
	month_year: monthDate,
	// department: String(department),
	// report_type: reportType,
  });
  



  const res = await fetch(`${API_BASE_URL}${PATH}?${q.toString()}`, {
	method: 'GET',
	headers: {
	  'Accept': 'application/vnd.ms-excel',
	  ...(localStorage.getItem('authToken') ? { Authorization: 'Bearer ' + localStorage.getItem('authToken') } : {}),
	},
	// credentials: 'include', // keep if your API uses session cookies
  });

  //console.log(res);

  if (!res.ok) {
	const text = await res.text().catch(() => '');
	throw new Error(`Download failed (${res.status}) ${text.slice(0, 200)}`);
  }

  const blob = await res.blob();
  const filename = filenameFromHeaders(res.headers, `esi_report_${monthYear}.xls`);
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}


async function downloadAllowanceXls({ monthYear, department = '0', reportType = 'allowance', token }) {
  // Pick the right path based on where your route lives:
  // routes/api.php  -> '/api/salary-report'
  // routes/web.php  -> '/salary-report'
  const PATH = '/allowance_deduction_report'; // change to '/salary-report' if your route is in web.php

  const monthDate = toLastDateISO(monthYear); // "2025-07" -> "2025-07-31"

  

  const q = new URLSearchParams({
	month_year: monthDate,
	// department: String(department),
	// report_type: reportType,
  });
  



  const res = await fetch(`${API_BASE_URL}${PATH}?${q.toString()}`, {
	method: 'GET',
	headers: {
	  'Accept': 'application/vnd.ms-excel',
	  ...(localStorage.getItem('authToken') ? { Authorization: 'Bearer ' + localStorage.getItem('authToken') } : {}),
	},
	// credentials: 'include', // keep if your API uses session cookies
  });

  //console.log(res);

  if (!res.ok) {
	const text = await res.text().catch(() => '');
	throw new Error(`Download failed (${res.status}) ${text.slice(0, 200)}`);
  }

  const blob = await res.blob();
  const filename = filenameFromHeaders(res.headers, `allowance_report_${monthYear}.xls`);
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

 async function handleDownload() {
  try {
	if (reportType !== 'salary_report') {
	  toast.info("Only 'Salary Report' is wired right now");
	  return;
	}
	await downloadSalaryXls({
	  monthYear: user.month_year,   // e.g. "2025-07"
	  department: user.department,  // "0" or dept id
	  reportType,                   // "salary_report"
	  token: localStorage.getItem('authToken'),
	});
	toast.success('Download started');
  } catch (e) {
	console.error(e);
	toast.error(e.message || 'Download failed');
  }
}



async function downloadAllowanceXls({ monthYear, department = '0', reportType = 'allowance', token }) {
  // Pick the right path based on where your route lives:
  // routes/api.php  -> '/api/salary-report'
  // routes/web.php  -> '/salary-report'
  const PATH = '/allowance_deduction_report'; // change to '/salary-report' if your route is in web.php

  const monthDate = toLastDateISO(monthYear); // "2025-07" -> "2025-07-31"

  

  const q = new URLSearchParams({
	month_year: monthDate,
	// department: String(department),
	// report_type: reportType,
  });
  



  const res = await fetch(`${API_BASE_URL}${PATH}?${q.toString()}`, {
	method: 'GET',
	headers: {
	  'Accept': 'application/vnd.ms-excel',
	  ...(localStorage.getItem('authToken') ? { Authorization: 'Bearer ' + localStorage.getItem('authToken') } : {}),
	},
	// credentials: 'include', // keep if your API uses session cookies
  });

  //console.log(res);

  if (!res.ok) {
	const text = await res.text().catch(() => '');
	throw new Error(`Download failed (${res.status}) ${text.slice(0, 200)}`);
  }

  const blob = await res.blob();
  const filename = filenameFromHeaders(res.headers, `allowance_report_${monthYear}.xls`);
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}


async function downloadLateXls({ monthYear, department = '0', reportType = 'late_report', token }) {
  // Pick the right path based on where your route lives:
  // routes/api.php  -> '/api/salary-report'
  // routes/web.php  -> '/salary-report'
  const PATH = '/late_report'; // change to '/salary-report' if your route is in web.php

  const monthDate = toLastDateISO(monthYear); // "2025-07" -> "2025-07-31"

  

  const q = new URLSearchParams({
	month_year: monthDate,
	// department: String(department),
	// report_type: reportType,
  });
  



  const res = await fetch(`${API_BASE_URL}${PATH}?${q.toString()}`, {
	method: 'GET',
	headers: {
	  'Accept': 'application/vnd.ms-excel',
	  ...(localStorage.getItem('authToken') ? { Authorization: 'Bearer ' + localStorage.getItem('authToken') } : {}),
	},
	// credentials: 'include', // keep if your API uses session cookies
  });

  //console.log(res);

  if (!res.ok) {
	const text = await res.text().catch(() => '');
	throw new Error(`Download failed (${res.status}) ${text.slice(0, 200)}`);
  }

  const blob = await res.blob();
  const filename = filenameFromHeaders(res.headers, `late_report_${monthYear}.xls`);
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}

 async function handleDownload() {
  try {
	if (reportType !== 'salary_report') {
	  toast.info("Only 'Salary Report' is wired right now");
	  return;
	}
	await downloadSalaryXls({
	  monthYear: user.month_year,   // e.g. "2025-07"
	  department: user.department,  // "0" or dept id
	  reportType,                   // "salary_report"
	  token: localStorage.getItem('authToken'),
	});
	toast.success('Download started');
  } catch (e) {
	console.error(e);
	toast.error(e.message || 'Download failed');
  }
}



 async function handleBankDownload() {
  try {
	if (reportType !== 'bank_report') {
	  toast.info("Only 'Bank Report' is wired right now");
	  return;
	}
	await downloadBankXls({
	  monthYear: user.month_year,   // e.g. "2025-07"
	  department: user.department,  // "0" or dept id
	  reportType,                   // "salary_report"
	  token: localStorage.getItem('authToken'),
	});
	toast.success('Download started');
  } catch (e) {
	console.error(e);
	toast.error(e.message || 'Download failed');
  }
}

 async function handleEsiDownload() {
  try {
	if (reportType !== 'esi') {
	  toast.info("Only 'Esi Report' is wired right now");
	  return;
	}
	await downloadEsiXls({
	  monthYear: user.month_year,   // e.g. "2025-07"
	  department: user.department,  // "0" or dept id
	  reportType,                   // "salary_report"
	  token: localStorage.getItem('authToken'),
	});
	toast.success('Download started');
  } catch (e) {
	console.error(e);
	toast.error(e.message || 'Download failed');
  }
}


 async function handleAllowanceDownload() {
  try {
	if (reportType !== 'allowance') {
	  toast.info("Only 'Allowance Report' is wired right now");
	  return;
	}
	await downloadAllowanceXls({
	  monthYear: user.month_year,   // e.g. "2025-07"
	  department: user.department,  // "0" or dept id
	  reportType,                   // "salary_report"
	  token: localStorage.getItem('authToken'),
	});
	toast.success('Download started');
  } catch (e) {
	console.error(e);
	toast.error(e.message || 'Download failed');
  }
}


 async function handleLateDownload() {
  try {
	if (reportType !== 'late_report') {
	  toast.info("Only 'Late Report' is wired right now");
	  return;
	}
	await downloadLateXls({
	  monthYear: user.month_year,   // e.g. "2025-07"
	  department: user.department,  // "0" or dept id
	  reportType,                   // "salary_report"
	  token: localStorage.getItem('authToken'),
	});
	toast.success('Download started');
  } catch (e) {
	console.error(e);
	toast.error(e.message || 'Download failed');
  }
}



const handleSubmit = async (e) => {
    e.preventDefault();
    // updateSalaryMonthLabel();
    // await fetchTotalAmount();


    if (user.action === 'fetch') {
      await fetchPayslipList();
    }
	else if (user.action === 'download') {

      if(reportType=='salary_report')
      {
        await handleDownload();
      }
      else if(reportType=='bank_report')
      {
        await handleBankDownload();
      }
      else if(reportType=='esi')
      {
        await handleEsiDownload();
      }
      else if(reportType=='allowance')
      {
        await handleAllowanceDownload();
      }
       else if(reportType=='late_report')
      {
        await handleLateDownload();
      }
      
	}
	
    // } else if (user.action === 'Download') {
    //   downloadReport();
    // }
  };
 



   const columns = [
	{ label: "Employee Id", key: "employee_id", sortable: true },
	{ label: "Employee Name", key: "employee_name", sortable: true },
	{ label: "Department", key: "dept_name", sortable: true },
  { label: "Total Days", key: "total_days", sortable: true },
  { label: "Gross Salary", key: "gross_salary", sortable: true },
  { label: "LOP", key: "lop", sortable: true },
  { label: "(Gross Salary-LOP)", key: "calc_gross_salary", sortable: true },
  { label: "Net Salary", key: "pay_amt", sortable: true },
  { label: "HR Status", key: "hr", sortable: true },
  { label: "Account Status", key: "account", sortable: true },
  { label: "CFO Status", key: "status", sortable: true },
  { label: "Payment Status", key: "action", sortable: true },
  { label: "function", key: "action", sortable: true }
];

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
						
						</div>
					</div>

	




					 <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
													<div className="card">
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">
															 <form onSubmit={handleSubmit} > 
					
																<div class="row">
					
													<div className="col-md-3 col-sm-3">
															<div className="form-group">
															
															<label className="form-label">Department</label>
															<select className="form-control show-tick" name="department"  isSearchable={true} // Enable search
														placeholder="Select a fruit..." value={user.department}  onChange={handelInput}>
															<option value="0">Select Department</option>
																{dataval.map(option => (
																<option key={option.department_id} value={option.department_id}>
																{option.department_name}
																</option>
																))}
														</select>
																
															</div>
														</div>



														


														<div className="col-md-2 col-sm-2">
																	<div className="form-group">
																	<label className="form-label">Select Month</label>
																	<input type="month" className="form-control" name="month_year" value={user.month_year}
													onChange={handelInput} placeholder="Month Year"/>
																
																	</div>
																</div>


														<div className="col-md-2 col-sm-2">
															<div className="form-group">
																<label className="form-label">Action</label>
																<select className="form-control show-tick" name="action" value={user.action} onChange={handelInput}>
																
																<option value="fetch">Fetch</option>
																<option value="download">Download</option>
                                                                
																</select>
															</div>
														</div>



														  {user.action === "download" && (
                <div className="col-md-2 col-sm-2">
                  <div className="form-group">
                  <label className="form-label">Report</label>
                  <select className="form-control show-tick"
                    value={reportType}
                    onChange={(e) => setReportType(e.target.value)}
                  >
                    <option value="salary_report">Salary Report</option>
                    <option value="bank_report">Bank Transfer</option>
                    <option value="esi">PF & ESI</option>
                    <option value="allowance">Allowance & Deduction</option>
                    <option value="late_report">Late Report</option>
                  </select>
                </div>
                </div>
              )}
					
														
														
												
					
													
													
					
					
													<div className="col-md-2 col-sm-2">
														<div className="form-group">
														
													<label><br /><br /></label>
													<button type="submit" className="btn btn-primary">
													GET
												</button>
					
												
												</div>
												</div>
					
					
					
												{/* <div className="col-md-2 col-sm-6">
														<div className="form-group">
					
												   
					
												<Link to={`/attendancecalendar`} className="btn btn-primary">Attendance Calendar</Link>
					
												</div>
												</div> */}
					
					
												</div>
					
												
												   
					
															   
					
					
															
						
															
																
															 </form>
														</div>
													</div>
												</div>
					
											</div>
										</div>
									</div>


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																<div>
  <h3 className="card-title" style={{color:'#e96827'}}>PAYMENT INFO</h3><br/>

 <h3
  className="card-title"
  style={{
    color: "#181412ff",
    fontWeight: "400",
    marginTop: "5px",
    whiteSpace: "nowrap"   // ⬅ forces single line
  }}
>
  Salary Generate For{" "}
  <span style={{ color: "#2744e9ff", fontWeight: "600" }}>{monthName}</span>{" "}
  Month
</h3>
</div>
																<div
  className="card-options"
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "6px",
    width: "100%"
  }}
>
  {/* TOTAL AMOUNT */}
  <div
    style={{
      fontSize: "16px",
      fontWeight: "600",
      color: "#0c2a4d",
      display: "flex",
      justifyContent: "flex-end"
    }}
  >
    Total Amount:{" "}
    <span style={{ color: "#e96827", marginLeft: "4px" }}>
      ₹ {totalAmount}
    </span>
  </div>

  {/* ROW: entries + search */}
  <div
    style={{
      display: "flex",
      gap: "10px",
      alignItems: "center"
    }}
  >
    <EntriesSelector
      setEntriesPerPage={setEntriesPerPage}
      setCurrentPage={setCurrentPage}
    />

    <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
  </div>
</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div
  className="table-responsive"
  style={{
    overflowX: "auto",
    overflowY: "auto",
    whiteSpace: "nowrap",
    maxHeight: "600px",
    background: "#fff",
  }}
>
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0" style={{ minWidth: "1200px" }}>
																		<thead>
																			 <tr>      
                                                                            <th>Action</th>
                                                                            {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}          
                                                                            </tr>
																		</thead>
																		<tbody>
																		{records.length > 0 ? (
																				filteredData.map((record) => {

                                           let action;

                                               
                                               
                                                                                                     
                                                 if ((record.cfo_verified === "VERD")&& (record.is_paid === "PAID") && (record.acc_verified=="INPR")) {
                                          
                                                                          
                                                                          action = <button className='btn' style={{ backgroundColor:'#4ded4d'}} onClick={() => handleUpdatePayslip(record.make_payment_id)}>PAID</button>;
                                              
                                                                          
                                          
                                          
                                                                                                              // action = <button className='btn' style={{ backgroundColor:'#4ded4d'}} onClick={() => handleUpdate(record.payment_id)}>PAID</button>;
                                               } else if ((record.cfo_verified === "VERD")&& (record.is_paid === "INPR")) {
                                                 action = <button className='btn' style={{backgroundColor:'#ff9e9ee6' }}>IN PROGRESS</button>;
                                                } else if (record.cfo_verified === "INPR") {
                                                 action = <button className='btn' style={{ backgroundColor:'#ff9e9ee6' }}>WAITING</button>;
                                              }
                                              else if (record.cfo_verified === "REGT") {
                                                action = <button className='btn' style={{ backgroundColor:'#ff9e9ee6' }}>HOLD</button>;
                                              } else {
                                                action = <button className='btn'>IN PROGRESS</button>;
                                              }
                                          


                                                                                
                                                               return(



																					<tr key={record.employee_id}>
                                                                                    <td style={{ textAlign: 'center' }}>
{/*<input
  type="checkbox"
  className="form-check-input"
  value={`${record.acc_verified}-${record.is_paid}-${record.make_payment_id}`}
  checked={!!checkedItems[record.make_payment_id]} // ✅ Reflects state
  onChange={(e) => {
    const isChecked = e.target.checked;
    const value = e.target.value;

    setCheckedItems((prev) => {
  const updated = { ...prev };
  if (isChecked) {
    updated[record.make_payment_id] = `INPR-PAID-${record.make_payment_id}`; // Add it
  } else {
    delete updated[record.make_payment_id];
  }
  return updated;
});
  }}
/>*/}
{record.hr_hold_status != 0 && (
   <>
<input
  type="checkbox"
  className="form-check-input"
  value={`${record.acc_verified}-${record.is_paid}-${record.make_payment_id}`}
   
  checked={checkedItems[record.employee_id] || false}  // ✅ USE UNIQUE ID
 onChange={(e) => {
    const isChecked = e.target.checked;
    const backendValue = e.target.value; 

    setCheckedItems(prev => {
      const updated = { ...prev };
      if (isChecked) {
        updated[record.employee_id] = backendValue; // ✅ store string value
      } else {
        delete updated[record.employee_id];
      }
      return updated;
    });
  }}
/>
<input type="hidden"  value={`${record.acc_verified}-${record.is_paid}-${record.make_payment_id}`}/>
</>
)}
</td>
																					<td>{record.employee_id}</td>
																					<td>{record.employee_name}<br/>{ReactHtmlParser(record.hold)}</td>
																					<td>{record.dept_name}</td>
																					<td>{record.total_days}</td>
																					<td>{record.gross_salary}</td>
																					<td>{record.lop}</td>
																					<td>{record.calc_gross_salary}</td>
                                                                                    <td>{record.pay_amt}<br/><button
																		type="button" onClick={() =>{ handleUpdate(record.user_id,record.pay_date)}}
																		className="btn btn-primary"
																		data-toggle="modal"
																		data-target="#payslipDetailsModal"
																		>
																	<i className="fa fa-rupee" />
																	</button></td>
																					<td>{ReactHtmlParser(record.hr)}</td>
																					<td>{ReactHtmlParser(record.account)}</td>
                                                                                    <td>{ReactHtmlParser(record.status)}</td>
                                                                                    <td>{action}</td>

																					
																				</tr>
                                                               )
})
																			) : (
																				<tr>
																				<td colSpan="12" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
								<Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />	

														<div className="d-flex gap-2 mt-3">
															<button className="tag tag-warning" onClick={handleCfoVerified}>
																<i className="fa fa-check-circle" style={{fontSize:'10px',fontWeight:'900',marginTop:'6px'}} /> Mark as Verified
															</button>
															
															</div>
													
					
															</div> 

															

					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>




			<div className="modal fade" id="payslipDetailsModal" tabIndex="-1" role="dialog" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Payment For {dialogmakepayment?.month_year}</h5>
        <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
      </div>
      <div className="modal-body">
        <div className="row">
          {/* Attendance Summary */}
          <div className="col-md-3">
            {[
              ['Total Days', dialogmakepayment.total_days, 'primary'],
              ['Presents', dialogmakepayment.presents, 'success'],
              ['Holidays', dialogmakepayment.holidays, 'warning'],
              ['Week Off', dialogmakepayment.week_off, 'info'],
              ['Absent', dialogmakepayment.absent, 'danger'],
              ['Paid leaves', dialogmakepayment.paid_leave, 'success'],
              ['LOP', dialogmakepayment.lop, 'danger'],
              ['SL & CL', dialogmakepayment.sl_cl, 'secondary'],
              ['CO & PL', dialogmakepayment.co_pl, 'secondary'],
              ['ML & SPL', dialogmakepayment.ml_spl, 'secondary'],
            ].map(([label, value, color], i) => (
              <div key={i} className={`border border-${color} rounded text-center text-${color} mb-2 p-1`}>
                <small>{label}</small><br /><strong>{value}</strong>
              </div>
            ))}
          </div>

          {/* Salary Tables */}
          <div className="col-md-9">
            <div className="row">
              <div className="col">
                <h6 className="text-center">Actual Salary</h6>
                <table className="table table-bordered table-sm">
                  <tbody>
                    {dialogmakepayment?.actual_salary &&
                      Object.entries(dialogmakepayment.actual_salary).map(([k, v]) => (
                        <tr key={k}><td>{k}</td><td>{v}</td></tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="col">
                <h6 className="text-center">Calculated Salary</h6>
                <table className="table table-bordered table-sm">
                  <tbody>
                    {dialogmakepayment?.calculated_salary &&
                      Object.entries(dialogmakepayment.calculated_salary).map(([k, v]) => (
                        <tr key={k}><td>{k}</td><td>{v}</td></tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




            




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(CfoVerification);